// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fade-enter-active{transition:all .3s ease}.fade-leave-active{transition:all .8s cubic-bezier(1,.5,.8,1)}.fade-enter,.fade-leave-to{opacity:0;transform:translateX(20px)}.expand-enter-active{transition:all .3s ease}.expand-leave-active{transition:all .8s cubic-bezier(1,.8,.5,0)}.expand-enter,.expand-leave-to{opacity:0;transform:translateY(-10px)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
